const autoLinkHtml = (inputHtml: string) => {
  const doc = new DOMParser().parseFromString(inputHtml, 'text/html');

  doc.body.normalize();

  const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;

  const makeAnchor = (text: string) => {
    const a = doc.createElement('a');
    const href = text.startsWith('http') ? text : `https://${text}`;
    a.setAttribute('href', href);
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
    a.textContent = text;
    return a;
  };

  const shouldSkipMatch = (fullText: string, start: number, end: number, matchText: string) => {
    if (matchText.includes('*')) return true;

    if (end < fullText.length && fullText[end] === '*') return true;

    if (start > 0 && fullText[start - 1] === '*') return true;

    const after = end < fullText.length ? fullText[end] : '';
    if (after && /[A-Za-z0-9_]/.test(after)) return true;

    return false;
  };

  const filter: NodeFilter = {
    acceptNode: (node: Node): number => {
      if (node.nodeType !== Node.TEXT_NODE) return NodeFilter.FILTER_REJECT;

      const text = node.nodeValue ?? '';
      if (!text.trim()) return NodeFilter.FILTER_REJECT;

      const parentEl = node.parentNode as Element | null;
      if (parentEl?.closest?.('a')) return NodeFilter.FILTER_REJECT;

      urlRegex.lastIndex = 0;
      return urlRegex.test(text) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
    },
  };

  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, filter);

  const textNodes: Text[] = [];
  let current: Node | null = walker.nextNode();
  while (current) {
    textNodes.push(current as Text);
    current = walker.nextNode();
  }

  for (const textNode of textNodes) {
    const text = textNode.nodeValue || '';
    urlRegex.lastIndex = 0;

    const matches = Array.from(text.matchAll(urlRegex));
    if (!matches.length) continue;

    const frag = doc.createDocumentFragment();
    let lastIndex = 0;

    for (const m of matches) {
      const matchText = m[0];
      const start = m.index ?? 0;
      const end = start + matchText.length;

      if (start > lastIndex) {
        frag.appendChild(doc.createTextNode(text.slice(lastIndex, start)));
      }

      if (shouldSkipMatch(text, start, end, matchText)) {
        frag.appendChild(doc.createTextNode(matchText));
      } else {
        frag.appendChild(makeAnchor(matchText));
      }

      lastIndex = end;
    }

    if (lastIndex < text.length) {
      frag.appendChild(doc.createTextNode(text.slice(lastIndex)));
    }

    textNode.parentNode?.replaceChild(frag, textNode);
  }

  return doc.body.innerHTML;
};

export default autoLinkHtml;
